/** Preserva letras do CNPJ alfanumérico e remove somente a máscara conhecida. */
export function normalizeCnpj(value: string): string {
  return value.toUpperCase().replace(/[.\/\-\s]/g, '');
}

export function formatCnpj(value: string): string {
  const cnpj = normalizeCnpj(value).replace(/[^A-Z0-9]/g, '').slice(0, 14);
  return cnpj.slice(0, 2) +
    (cnpj.length > 2 ? `.${cnpj.slice(2, 5)}` : '') +
    (cnpj.length > 5 ? `.${cnpj.slice(5, 8)}` : '') +
    (cnpj.length > 8 ? `/${cnpj.slice(8, 12)}` : '') +
    (cnpj.length > 12 ? `-${cnpj.slice(12, 14)}` : '');
}

/** Módulo 11 oficial: letras recebem seu valor ASCII menos 48. */
export function isValidCnpj(value: string): boolean {
  const cnpj = normalizeCnpj(value);
  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj) || /^(.)\1{13}$/.test(cnpj)) return false;
  const calculate = (base: string, weights: number[]) => {
    const sum = weights.reduce((total, weight, index) => total + (base.charCodeAt(index) - 48) * weight, 0);
    const remainder = sum % 11;
    return remainder < 2 ? 0 : 11 - remainder;
  };
  return calculate(cnpj, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(cnpj[12]) &&
    calculate(cnpj, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(cnpj[13]);
}
